//development
// Temporarily using any for models during migration
// import { Cash } from "src/app/shared/model/cash";
// import { Product } from "src/app/shared/model/product";

export const environment = {
  production: false,
  name: 'development',
  products: new Array() as Array<any>,
  barcodeFocus: true,
  cash: {} as any,
  cashIsOpen: false,
  APIGW_ENABLE: true,
  APIGW_HOST: 'zb42iuuddf.execute-api.us-west-2.amazonaws.com',
  BASE_API_URL: '',
  BASE_API_URL_WHITOUT_SUBDOMAIN: '.demo.vunblox.com/api/companyx',
  BASE_API_PROTOCOL: 'https://',
  pathLogin: 'api/companyx/v1/auth/login',
  pathCash: 'api/companyx/v1/cash',
  token: '',
  roles: new Map<String, string>(),
  userPermissions: null as any, // Permisos del usuario (solo para admin/super user)
  idBranchOffice: 0,
  branchOfficeName: '',
  title: '',
  branchOfficeIdCurrentParam: 0, // ID de sucursal actual seleccionada (solo para admin/super user)
  branchOfficeIdMain: 22, // ID de la sucursal principal
  timeOutGet: 20000,
  timeOut: 35000,
  autologin: false, // solo para el login local
  username: '', //solo para el login local
  password: '',// solo para el login local
  wsUrl: 'https://ws.utilerp.com',
  // wsApiKey: REMOVED - El API Key ahora se obtiene del campo 'apiKeyServerSocket' del JWT decodificado
}